type ValidationErrorMapper = string | ((error: unknown) => string);

export const VALIDATION_ERRORS: Record<string, ValidationErrorMapper> = {
  required: 'This field is required.',
  email: 'Enter a valid email address.',
  valueDoesNotMatch: 'Email addresses do not match.',
  invalidDateRange: 'Date to cannot be earlier than date from.',
  invalidRouteSequence: 'Start date must be after the previous end date.',
};
